// extracted by mini-css-extract-plugin
module.exports = {"customLayoutWrapper":"CustomLayoutView_customLayoutWrapper__3VPYF"};